export function getTypeBanner(searchPageType) {
	const typesPages = {
		searchPage: searchPageType,
		atlasPage: 'atlas',
		main: 'mainpage',
		railwaySearchPage: 'sideBanner',
	};
	const currentTypePage = window?.appConfig?.pageType;
	const typePage = typesPages[currentTypePage];
	return typePage || 'lifehackBanner';
}